import React from "react";

import {Card, Divider, Grid, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import finishIcon from '../../assets/end.png'
import startIcon from '../../assets/start.png'

const DistanceIcon = ({className} : any) => {
    return (<svg className={className} fill={"darkgray"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
            d="M399.959 170.585c-4.686 4.686-4.686 12.284 0 16.971L451.887 239H60.113l51.928-51.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-84.485 84c-4.686 4.686-4.686 12.284 0 16.971l84.485 84c4.686 4.686 12.284 4.686 16.97 0l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273h391.773l-51.928 51.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l84.485-84c4.687-4.686 4.687-12.284 0-16.971l-84.485-84c-4.686-4.686-12.284-4.686-16.97 0l-7.07 7.071z"/>
    </svg>)
}
const TachoAverageIcon = ({className} : any) => {
    return (<svg className={className} fill={"darkgray"} xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 576 512">
        <path
            d="M304 290.26V128c0-8.84-7.16-16-16-16s-16 7.16-16 16v162.26c-27.56 7.14-48 31.95-48 61.74 0 35.35 28.65 64 64 64s64-28.65 64-64c0-29.79-20.44-54.6-48-61.74zM288 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-352C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm221.5 416l-442.8.68C44 409.75 32 365.26 32 320 32 178.84 146.84 64 288 64s256 114.84 256 256c0 45.26-12 89.75-34.5 128z"/>
    </svg>)
}
const TachoFastestIcon = ({className} : any) => {
    return (<svg className={className} fill={"darkgray"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M477.38 304.22l-130.97 21.83C336.44 303.66 314.09 288 288 288c-35.35 0-64 28.65-64 64s28.65 64 64 64c33.41 0 60.53-25.7 63.43-58.35l131.2-21.87c8.72-1.45 14.62-9.69 13.16-18.41s-9.88-14.64-18.41-13.15zM288 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-352C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm221.5 416l-442.8.68C44 409.75 32 365.26 32 320 32 178.84 146.84 64 288 64s256 114.84 256 256c0 45.26-12 89.75-34.5 128z"/></svg>)
}
const ClockIcon = ({className} : any) => {
    return (<svg className={className} fill={"darkgray"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-148.9 88.3l-81.2-59c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h14c6.6 0 12 5.4 12 12v146.3l70.5 51.3c5.4 3.9 6.5 11.4 2.6 16.8l-8.2 11.3c-3.9 5.3-11.4 6.5-16.8 2.6z"/></svg>)
}

const useStyles = makeStyles(() => ({
    card: {
        marginBottom: '0',
        padding: '7px',
        cursor: "pointer",
        display: "flex",
        flexDirection: 'column',
    },
    item: {
        display: "flex",
        flexDirection: "row",
        alignItems: 'center',
        justifyContent: 'center'
    },
    icon: {
        height: '25px',
        width: '25px'
    },
    svgIcon: {
        height: '16px',
        width: '16px',
        marginRight: '6px'
    },
    day: {
        textAlign: 'center',
        background: '#e1e1e1',
        fontWeight: 'bold',
        color: 'gray',
        fontSize: '15px',
        padding: '15px',
        borderRadius: 0
    },
    dayOrange: {
        background: '#c97200',
        color: '#fff',
    }
}))

export type TripProps = {
    trip: {
        id: string,
        start_address: string,
        end_address: string,
        started_at: string,
        ended_at: string,
        distance: number,
        duration: number,
        average_speed: number,
        max_speed?: number
    };
    getTrip: (id: string) => Promise<void>;
    dates: Array<string>;
    index: number;
    dayColor?: 'orange';
}


const Trip = ({ trip, getTrip, index, dates, dayColor} : TripProps) => {
    const classes = useStyles()
    // const duration = moment(trip.trip_ended_at).diff(trip.trip_started_at, 'seconds')

    const hhmm = (seconds: number) => {
        const hours = Math.floor((seconds / 3600));
        const minutes = Math.floor(seconds % 3600 / 60);
        return ('0' + hours).slice(-2) + ":" + ('0' + minutes).slice(-2);
    }

    const showDate = () => {
        const card = <Card elevation={0} className={dayColor === 'orange' ? `${classes.day} ${classes.dayOrange}` : classes.day }>{dates[index]}</Card>
        if(index === 0) {
            return card
        } else if (dates[index - 1] === dates[index]) {
            return null
        } else {
            return card
        }
    }

    return (
        <div>
            {showDate()}
            <Card elevation={0} key={trip.id} className={classes.card} onClick={() => getTrip(trip.id)}>
                <Grid item className={classes.item} >
                    <Grid xs={1} item className={classes.item}>
                        <img src={finishIcon} className={classes.icon} alt="end time" />
                    </Grid>
                    <Grid xs={3} item className={classes.item}>
                        <Typography variant="h5" component="h2" style={{fontSize: '16px', marginRight: '24px'}} color="textSecondary">{new Date(trip.ended_at).toLocaleTimeString().slice(0, -3)}</Typography>
                    </Grid>
                    <Grid xs={8} item className={classes.item}>
                        <Typography variant="h5" component="h2" style={{fontSize: '14px', textAlign: 'start', marginBottom: '14px'}} color="textSecondary">{trip.end_address}</Typography>
                    </Grid>
                </Grid>
                <Grid item className={classes.item}>
                    <Grid xs={1} item className={classes.item}>
                        <img src={startIcon} className={classes.icon} alt="start time" />
                    </Grid>
                    <Grid xs={3} item className={classes.item}>
                        <Typography variant="h5" component="h2" style={{fontSize: '16px', marginRight: '24px'}} color="textSecondary">{new Date(trip.started_at).toLocaleTimeString().slice(0, -3)}</Typography>
                    </Grid>
                    <Grid xs={8} item className={classes.item}>
                        <Typography variant="h5" component="h2" style={{fontSize: '14px', textAlign: 'start'}} color="textSecondary">{trip.start_address}</Typography>
                    </Grid>
                </Grid>
                <Grid item className={classes.item} style={{alignItems: 'flex-end', padding: '5px 5px 0 5px'}}>
                    <Grid xs={3} item style={{alignItems: 'flex-end'}} className={classes.item}>
                        <DistanceIcon className={classes.svgIcon}/>
                        <Typography variant="h5" component="h2" style={{fontSize: '11px', textAlign: 'start'}} color="textSecondary">{(trip.distance / 1000).toFixed(2) || 0.00} km</Typography>
                    </Grid>
                    <Grid xs={3} item  className={classes.item}>
                        <TachoAverageIcon className={classes.svgIcon}/>
                        <Typography variant="h5" component="h2" style={{fontSize: '11px', textAlign: 'start', marginTop: '4px'}} color="textSecondary">{(trip.average_speed).toFixed(2) || 0.00} km/h</Typography>
                    </Grid>
                    {trip.max_speed && <Grid xs={3} item className={classes.item}>
                        <TachoFastestIcon className={classes.svgIcon}/>
                        <Typography variant="h5" component="h2"
                                    style={{fontSize: '11px', textAlign: 'start', marginTop: '4px'}}
                                    color="textSecondary">{trip.max_speed} km/h</Typography>
                    </Grid>}
                    <Grid xs={3} item  className={classes.item}>
                        <ClockIcon className={classes.svgIcon} />
                        <Typography variant="h5" component="h2" style={{fontSize: '11px', textAlign: 'start', marginTop: '2px'}} color="textSecondary">{ hhmm(trip.duration)}</Typography>
                    </Grid>
                </Grid>
            </Card>
            <Divider />
        </div>
    )
}

export default Trip
